import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

/**
 * Plain-language, sign-colored monthly-revenue trend.
 * Green ↑ when growing, red ↓ when shrinking — never green for a decline.
 * `long` shows the human sentence ("in the last 30 days"); compact shows "30d".
 */
export const GrowthChip = ({ value, long = false, className = "" }) => {
  if (value == null || value === "None") return null;
  const v = Math.round(Number(value));
  if (Number.isNaN(v)) return null;
  const up = v >= 0;
  const color = up ? "text-emerald-600" : "text-rose-600";
  const Icon = up ? ArrowUpRight : ArrowDownRight;
  const label = long
    ? `${up ? "up" : "down"} ${Math.abs(v)}% in the last 30 days`
    : `${Math.abs(v)}% · 30d`;
  return (
    <span
      className={`inline-flex items-center gap-0.5 font-medium ${color} ${className}`}
      title="Change in monthly revenue over the last 30 days"
    >
      <Icon size={long ? 13 : 11} />
      {label}
    </span>
  );
};

export default GrowthChip;
